module.exports = __webpack_public_path__ + "static/media/work3.c1703e49.jpg";